<template>
    <div class="stock-box">
        <HeaderNav
            header-title="库存情况"
            left-icon-name="2"
            right-icon-name="2"
            @change-org="handleChangeOrg"
        ></HeaderNav>
        <monthSelectTitle :tit="title" @change-month="changeMonth"></monthSelectTitle>
        <!-- 弹出日历控件 -->
        <van-popup
            v-model="showCalendar"
            position="bottom"
            :style="{ height: '50%' }"
        >
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                :formatter="formatter"
                :max-date="maxDate"
                @confirm="confirmMonth"
                @cancel="cancelMonth"
            ></van-datetime-picker>
        </van-popup>
        <div class="warpper">
            <div class="chart-title-con">
                <h4 class="chart-title">
                    <span class="title">库存</span>
                    <span class="subtitle">单位(吨)</span>
                </h4>
                <h4 class="chart-title">
                    <span class="title">占压资金</span>
                    <span class="subtitle">单位(万元)</span>
                </h4>
            </div>

            <div class="container">
                <div class="stock">
                    <div class="item" v-for="item in stockData" :key="item.sort_num">
                        <div class="item-box upper" :class="`color${item.sort_num}`">
                            <div class="top">
                                <div class="tit" v-text="item.type_name"></div>
                                <div class="contrast " :class="[{'contrast-up':item.stock_change>0},{'contrast-down':item.stock_change<0}]">
                                    <span class="text">
                                        较上月
                                    </span>
                                    <div class="num-box">
                                        <span class="num">{{ item.stock_change|absNum|toFixedNumber }}</span>
                                        <span class="arrow iconfont iconshangsheng" v-if="item.stock_change>0"></span>
                                        <span class="arrow iconfont iconxiajiang" v-if="item.stock_change<0"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom">
                                <van-row>
                                    <van-col span="8">
                                        <div class="chart" :id="`liquidFill${item.sort_num}`"></div>
                                    </van-col>
                                    <van-col span="16">
                                        <div class="stock-num">
                                            <div class="num-item">
                                                <label>核定:</label>
                                                <span>{{ item.stock_auth|toFixedNumber }}</span>
                                            </div>
                                            <div class="num-item">
                                                <label>
                                                    期末:
                                                </label>
                                                <span>{{ item.stock_end|toFixedNumber }}</span>
                                            </div>
                                        </div>
                                    </van-col>
                                </van-row>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overstock-fund">
                    <div
                        class="item"
                        v-for="item in stockRateData"
                        :key="item.type_code"
                        :class="`color${item.sort_num}`"
                    >
                        <div class="item-box">
                            <h4 v-text="item.type_name"></h4>
                            <div class="end-term">
                                <span class="num" v-text="item.fund_end"></span>
                                <span class="tag">期末值</span>
                            </div>
                            <div class="split-line"></div>
                            <div class="ratio">
                                <div class="ratio-item" :class="[{'ratio-item-up':item.year>0}, {'ratio-item-down':item.year<0}]">
                                    <div class="num">
                                        <span>{{ item.year|absNum|num100|toFixedNumber }}%</span>
                                    </div>
                                    <div class="text">
                                        <span>同比</span>
                                        <span
                                            class="iconfont iconshangsheng"
                                            v-if="item.year>0"
                                        ></span>
                                        <span
                                            class="iconfont iconxiajiang"
                                            v-if="item.year<0"
                                        ></span>
                                    </div>
                                </div>
                                <div class="ratio-item" :class="[{'ratio-item-up':item.chain>0}, {'ratio-item-down':item.chain<0}]">
                                    <div class="num">
                                        <span>{{ item.chain|absNum|num100|toFixedNumber }}%</span>
                                    </div>
                                    <div class="text">
                                        <span>环比</span>
                                        <span
                                            class="iconfont iconshangsheng"
                                            v-if="item.chain>0"
                                        ></span>
                                        <span
                                            class="iconfont iconxiajiang"
                                            v-if="item.chain<0"
                                        ></span>
                                    </div>
                                </div>
                                <div
                                    class="ratio-item"
                                    :class="[{'ratio-item-up':item.year_begin>0}, {'ratio-item-down':item.year_begin<0}]"
                                >
                                    <div class="num">
                                        <span>{{ item.year_begin|absNum|num100|toFixedNumber }}%</span>
                                    </div>
                                    <div class="text">
                                        <span>比年初</span>
                                        <span
                                            class="iconfont iconshangsheng"
                                            v-if="item.year_begin>0"
                                        ></span>
                                        <span
                                            class="iconfont iconxiajiang"
                                            v-if="item.year_begin<0"
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import monthSelectTitle from '@/components/header-nav/monthSelectTitle';
import 'echarts-liquidfill';
import utils from '@/assets/js/utils';
import { Dialog } from 'vant';
export default {
    name: 'stock',
    components: {
        HeaderNav, monthSelectTitle,
    },
    data() {
        return {
            title: '', // 标题
            showCalendar: false, // 是否展示日历选择
            orgId: '', // 当前组织ID
            year: '', // 年
            month: '', // 月
            currentDate: new Date(),
            maxDate: '',
            colorData: ['#5588F1', '#FA8436', '#8B6BEE', '#21BDCC', '#F1B000', '#EB656F'], // 水球颜色值
            stockData: [], // 库存data
            stockRateData: [], // 占压资金data
        };
    },
    methods: {
        drawLiuQiu(itemData, index) {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('liquidFill' + itemData.sort_num));
            // 指定图表的配置项和数据
            const option = {
                series: [{
                    type: 'liquidFill',
                    data: [itemData.stock_rate],
                    radius: '90%',
                    // 水球颜色
                    color: [this.colorData[index]],
                    outline: {
                        borderDistance: 2,
                        itemStyle: {
                            borderWidth: 2,
                            borderColor: this.colorData[index],
                        },
                    },
                    label: {
                        normal: {
                            color: this.colorData[index],
                            insideColor: '#fff',
                            fontSize: 14,
                        },
                    },
                    // 内图 背景色 边
                    backgroundStyle: {
                        color: '#fff',
                    },
                }],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },

        // 切换运营区
        handleChangeOrg(value) {
            this.orgId = value;
            this.getStockInfo();
            this.getStockRate();
        },
        // 按月下来筛选
        changeMonth() {
            this.showCalendar = true;
        },
        // 时间格式化
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
        // 返回的时间格式化
        formatDate(date) {
            return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        },
        // 时间选择完成
        confirmMonth(value) {
            const timeStr = this.formatDate(value);
            const timeArr = timeStr.split('/');
            // eslint-disable-next-line radix
            this.year = parseInt(timeArr[0]);
            // eslint-disable-next-line radix
            this.month = parseInt(timeArr[1]);
            this.showCalendar = false;
            this.title = this.year + '年' + this.month + '月份，中国联合水泥商混业务库存情况';
            this.getStockInfo();
            this.getStockRate();
        },
        // 取消时间选择
        cancelMonth() {
            this.showCalendar = false;
        },
        // 拉取库存情况
        getStockInfo() {
            this.$axios
                .get('/interfaceApi/report/StockManager/get_stock_info/' + this.year + '/' + this.month + '/' + this.orgId)
                .then(res => {
                    if (res) {
                        this.stockData = res;
                        this.$nextTick(function () {
                            for (let i = 0; i < res.length; i++) {
                                this.drawLiuQiu(res[i], i);
                            }
                        });
                    }
                }).catch(error => {
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
        // 拉取占压资金情况
        getStockRate() {
            this.$axios
                .get('/interfaceApi/report/StockManager/get_stock_rate/' + this.year + '/' + this.month + '/' + this.orgId)
                .then(res => {
                    if (res) {
                        res.map(item => {
                            if (item.fund_end) {
                                item.fund_end = (item.fund_end / 10000).toFixed(2);
                            }
                        });
                        this.stockRateData = res;
                    }
                }).catch(error => {
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
    },
    created() {
        const value = this.$store.state.orgData[0].value;
        this.orgId = value;
        const obj = utils.getPreMon();
        this.year = obj.year;
        this.month = obj.month;
        this.maxDate = new Date(obj.year, obj.month - 1, obj.lastDate);
        this.year = 2019;
        this.month = 12;
        this.title = this.year + '年' + this.month + '月份，中国联合水泥商混业务库存情况';
        this.getStockInfo();
        this.getStockRate();
    },
};
</script>

<style lang="stylus" scoped>
.stock-box
    padding-top 74rpx
    height calc(100% - 74rpx)
    .warpper
        height 100%
        overflow-x hidden
        overflow-y auto
        -webkit-overflow-scrolling touch
        .header
            width 100%
            height 30rpx
            background #F0F0F0
            font-size 12rpx
            text-align center
            line-height 30rpx
            .iconrili
                font-size 14rpx
                margin-right 6rpx
        .chart-title-con
            display flex
            .chart-title
                flex 1
                padding 15rpx 3% 10rpx
                font-size 16rpx
                position relative
                .title
                    color #3495FB
                .subtitle
                    float right
                    color #979EA7
                    font-size 10rpx
                    padding-top 4rpx
        .split
            width 100%
            height 15rpx
            background #F0F0F0
        .container
            display flex
            .stock
                flex 1
                overflow hidden
                .item
                    padding 8rpx
                    .item-box
                        height 130rpx
                        width 100%
                        border 1px solid #F0F0F0
                        box-shadow 1px 2px 6px 0px #F0F0F0
                        border-radius 4rpx
                        .top
                            display flex
                            justify-content space-between
                            .tit
                                width 30%
                                float left
                                font-size 14rpx
                                padding 14rpx 0 14rpx 6rpx
                            .contrast
                                width 70%
                                float right
                                padding 4rpx
                                margin 4rpx 4rpx
                                .text
                                    color #979EA7
                                    font-size 10rpx
                                    display block
                                    text-align center
                                .num-box
                                    text-align center
                                    .num
                                        font-size 13rpx
                                        color #333
                                        text-align center
                                    .arrow
                                        font-size 11rpx
                                        margin-top 2rpx
                                &.contrast-up
                                    background rgba(235,101,111,0.06)
                                    .arrow
                                        color #D6010F
                                &.contrast-down
                                    background rgba(24,160,1,0.06)
                                    .arrow
                                        color #18A001
                        .bottom
                            margin-top 10rpx
                            .chart
                                width 100%
                                height 54rpx
                            .stock-num
                                width 100%
                                .num-item
                                    width 100%
                                    overflow hidden
                                    text-overflow ellipsis
                                    white-space nowrap
                                    margin-top 5rpx
                                    margin-left 2rpx
                                    label
                                        font-size 10rpx
                                    span
                                        font-size 14rpx
                        &.color1
                            .stock-num
                                .num-item
                                    span
                                        color #3495FB
                        &.color2
                            .stock-num
                                .num-item
                                    span
                                        color #FA8436
                        &.color3
                            .stock-num
                                .num-item
                                    span
                                        color #8B6BEE
                        &.color4
                            .stock-num
                                .num-item
                                    span
                                        color #21BDCC
                        &.color5
                            .stock-num
                                .num-item
                                    span
                                        color #F1B000
                        &.color6
                            .stock-num
                                .num-item
                                    span
                                        color #EB656F
            .overstock-fund
                flex 1
                .item
                    padding 8rpx
                    .item-box
                        height 130rpx
                        width 100%
                        border 1px solid #F0F0F0
                        box-shadow 1px 2px 6px 0px #F0F0F0
                        border-radius 4rpx
                    h4
                        font-size 14rpx
                        padding 4rpx 8rpx
                    .end-term
                        padding 0 8rpx
                        overflow hidden
                        .num
                            float left
                            font-size 18rpx
                            color #5588F1
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                        .tag
                            float left
                            width 52rpx
                            height 20rpx
                            color #5588F1
                            font-size 10rpx
                            text-align center
                            line-height 21rpx
                            background url(./images/cost_icon1.png) no-repeat
                            background-size 100% 100%
                            text-align center
                            padding-left 3rpx
                    .split-line
                        border-bottom 1px dashed #F0F0F0
                        margin 10rpx 0
                    .ratio
                        display flex
                        .ratio-item
                            flex 0 0 30%
                            margin-left 2%
                            background rgba(235,101,111,0.06)
                            text-align center
                            padding 0 0 5rpx 0
                            .num
                                font-size 12rpx
                                margin 3rpx 0
                                .iconfont
                                    font-size 12rpx
                            .text
                                font-size 10rpx
                                color #979EA7
                                .iconfont
                                    font-size 12rpx
                            &.ratio-item-up
                                background rgba(235,101,111,0.06)
                                .text
                                    .iconfont
                                        color #EB656F
                            &.ratio-item-down
                                background rgba(85,136,241,0.06)
                                .text
                                    .iconfont
                                        color #18A001
                    &.color1
                        .end-term
                            .num
                                color #5588F1
                            .tag
                                color #5588F1
                                background url(./images/cost_icon1.png) no-repeat
                                background-size 100% 100%
                    &.color2
                        .end-term
                            .num
                                color #FA8436
                            .tag
                                color #FA8436
                                background url(./images/cost_icon2.png) no-repeat
                                background-size 100% 100%
                    &.color3
                        .end-term
                            .num
                                color #8B6BEE
                            .tag
                                color #8B6BEE
                                background url(./images/cost_icon3.png) no-repeat
                                background-size 100% 100%
                    &.color4
                        .end-term
                            .num
                                color #21BDCC
                            .tag
                                color #21BDCC
                                background url(./images/cost_icon4.png) no-repeat
                                background-size 100% 100%
                    &.color5
                        .end-term
                            .num
                                color #F1B000
                            .tag
                                color #F1B000
                                background url(./images/cost_icon5.png) no-repeat
                                background-size 100% 100%
                    &.color6
                        .end-term
                            .num
                                color #EB656F
                            .tag
                                color #EB656F
                                background url(./images/cost_icon6.png) no-repeat
                                background-size 100% 100%

</style>